import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, mergeProps as _mergeProps, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "contact-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "center black" }, "Érdeklődéssel várjuk kérdéseit, észrevételeit!", -1)
const _hoisted_3 = { class: "form-wrapper contact-form mt-50" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = { class: "input-wrapper" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "error" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Név megadása kötelező")
], -1)
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "input-wrapper" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "error" }, [
  /*#__PURE__*/_createElementVNode("p", null, "E-mail cím megadása kötelező")
], -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = { class: "input-wrapper" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "error" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Űzenet megadása kötelező")
], -1)
const _hoisted_15 = { class: "row mt-50" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "input-wrapper" }
const _hoisted_18 = { class: "table-coll checkbox-wrapper" }
const _hoisted_19 = { class: "checkbox-wrapper" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, [
  /*#__PURE__*/_createTextVNode("Elolvastam és elfogadom az "),
  /*#__PURE__*/_createElementVNode("a", { href: "" }, "adatvédelmi nyilatkozatot.")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "error" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Adatvédelmi nyilatkozat elfogadása kötelező")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "input-wrapper center" }, [
      /*#__PURE__*/_createElementVNode("button", { class: "btn primary" }, "Üzenet küldése")
    ])
  ])
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "input-wrapper center" }, [
      /*#__PURE__*/_createElementVNode("h1", { class: "center black" }, "Köszönjük üzenetét!")
    ])
  ])
], -1)
const _hoisted_25 = { class: "form-wrapper contact-form mt-50" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "input-wrapper center" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "center" }, " Munkatársunk hamarosan felveszi Önnel a kapcsolatot.")
    ])
  ])
], -1)
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-12" }
const _hoisted_29 = { class: "input-wrapper center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isSent)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Form, {
              "validation-schema": _ctx.schema,
              onSubmit: _ctx.send
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_Field, {
                        modelValue: _ctx.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                        name: "name",
                        placeholder: "Név"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, { name: "name" }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Field, {
                        modelValue: _ctx.email,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                        name: "email",
                        placeholder: "E-mail cím"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, { name: "email" }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_Field, {
                        modelValue: _ctx.message,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.message) = $event)),
                        name: "message"
                      }, {
                        default: _withCtx(({field}) => [
                          _withDirectives(_createElementVNode("textarea", _mergeProps({
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.message) = $event)),
                            name: "message",
                            placeholder: "Üzenet"
                          }, field), null, 16), [
                            [_vModelText, _ctx.message]
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, { name: "message" }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_Field, {
                        modelValue: _ctx.terms,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.terms) = $event)),
                        name: "terms",
                        type: "checkbox"
                      }, {
                        default: _withCtx(({terms1}) => [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("label", _hoisted_19, [
                              _withDirectives(_createElementVNode("input", _mergeProps({
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.terms) = $event)),
                                name: "terms",
                                type: "checkbox"
                              }, terms1), null, 16), [
                                [_vModelCheckbox, _ctx.terms]
                              ]),
                              _hoisted_20,
                              _hoisted_21
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, { name: "terms" }, {
                        default: _withCtx(() => [
                          _hoisted_22
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _hoisted_23
              ]),
              _: 1
            }, 8, ["validation-schema", "onSubmit"])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isSent)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("button", {
                    class: "btn primary center mt-50 small",
                    href: "javascript:undefined",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.back()))
                  }, "Vissza ")
                ])
              ])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}